import { openBlock as e, createElementBlock as t, createElementVNode as o } from "vue";
const c = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 48"
}, n = /* @__PURE__ */ o("path", { d: "M10.74 5.79h1.92c.53 0 .96.43.96.96v34.458c0 .53-.43.96-.96.96h-1.92a.96.96 0 0 1-.96-.96V6.75c0-.53.43-.96.96-.96Zm27.18 34.545-1.359 1.353.021.024a.96.96 0 0 1-1.353 0l-17.72-17.7 17.7-17.7a.96.96 0 0 1 1.352 0l1.36 1.353c.087.086.158.188.21.3a.961.961 0 0 1 0 .735 1.003 1.003 0 0 1-.21.3l-15 15 15 15a.945.945 0 0 1 .206.3.953.953 0 0 1 0 .735.915.915 0 0 1-.207.3Z" }, null, -1), r = [
  n
];
function a(l, s) {
  return e(), t("svg", c, r);
}
const h = { render: a };
export {
  h as default,
  a as render
};
//# sourceMappingURL=first-page.svg.mjs.map
